function cityNavigation(){
    const navItems = document.querySelectorAll('.sf-navigation-list ul li span');
    navItems.forEach(item => {
        //click first city item on load
        const firstCity = document.querySelector('.section--sf-city:has(.sf-city[data-nav="' + navItems[0].getAttribute('data-nav') + '"])');
        if( firstCity){
            firstCity.style.display = 'block';
        }

        item.addEventListener('click', function() {
            navItems.forEach(item => {
                item.classList.remove('active');
            });
            item.classList.add('active');
            const nav = item.getAttribute('data-nav');
            var cityItem = document.querySelector('.section--sf-city:has(.sf-city[data-nav="' + nav + '"])');
            var cityItems = document.querySelectorAll('.section--sf-city');
            cityItems.forEach(city => {
                city.style.display = 'none';
            });
            if(cityItem){
                cityItem.style.display = 'block';
            }
            //scroll screen to top of city section
            window.scrollTo({
                top: 0 ,
                behavior: 'smooth'
            });
        });

        //also on enter
        item.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                item.click();
            }
        });
    });
   
    // Get the current day and update schedule for each city
    var cityItems = document.querySelectorAll('.sf-city-item');
    cityItems.forEach(function(item) {
        // Get the current day
        var today = new Date().getDay();

        // Adjust for Sunday
        if (today === 0) {
            today = 7;
        }

        // Find the corresponding schedule for the current day
        var scheduleToday = item.querySelector('.sf-city-schedule').querySelectorAll('li')[today - 1].querySelector('.time').innerText;

        // Update the schedule display
        item.querySelector('.sf-city-schedule-today span').innerText = scheduleToday;
    });
}

function citySelected(section){
    const navItems = document.querySelectorAll('.sf-navigation-list ul li span');
    var cityItem = document.querySelector('#shopify-section-' + section);
    navItems.forEach(item => {
        item.classList.remove('active');
    });


    var navItem = document.querySelector('.sf-navigation-list ul li span[data-nav="' + cityItem.querySelector('.sf-city').getAttribute('data-nav') + '"]');
    navItem.classList.add('active');
    var cityItems2 = document.querySelectorAll('.section--sf-city');
    cityItems2.forEach(city => {
        city.style.display = 'none';
    });
    if(cityItem){
        cityItem.style.display = 'block';
    }
    //scroll screen to top of page
    window.scrollTo({
        top: 0 ,
        behavior: 'smooth'
    });


    // Get the current day and update schedule for each city
    var cityItems = document.querySelectorAll('.sf-city-item');
    cityItems.forEach(function(item) {
        // Get the current day
        var today = new Date().getDay();

        // Adjust for Sunday
        if (today === 0) {
            today = 7;
        }

        // Find the corresponding schedule for the current day
        var scheduleToday = item.querySelector('.sf-city-schedule').querySelectorAll('li')[today - 1].querySelector('.time').innerText;

        // Update the schedule display
        item.querySelector('.sf-city-schedule-today span').innerText = scheduleToday;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    cityNavigation();
});